import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';

import {
  chevronBack,
  menu,
  ellipsisHorizontal,
  shareOutline,
  heart,
  heartOutline,
} from 'ionicons/icons';

import { IonIcon, IonGrid, IonRow, IonCol, IonButton } from '@ionic/vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CourseletControls',
  props: {
    isFav: { type: Boolean },
    isQuiz: { type: Boolean },
    lastSlide: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  isFav: boolean;
  isQuiz: boolean;
  lastSlide: boolean;
}



const favIcon = computed(() => (props.isFav ? heart : heartOutline));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonGrid), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonRow), { class: "ion-justify-content-between" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCol), { size: "4" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButton), {
                shape: "round",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    slot: "start",
                    icon: _unref(chevronBack)
                  }, null, 8, ["icon"]),
                  _createTextVNode(" Back ")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (__props.lastSlide)
            ? (_openBlock(), _createBlock(_unref(IonCol), {
                key: 0,
                class: "ion-align-self-end"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), {
                    shape: "round",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('finish')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Finish ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : (__props.isQuiz)
              ? (_openBlock(), _createBlock(_unref(IonCol), {
                  key: 1,
                  class: "ion-align-self-end"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonButton), {
                      shape: "round",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('checkAnswer')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Check Answer ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createVNode(_unref(IonCol), { size: "2" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonButton), {
                        shape: "round",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('menu')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            slot: "icon-only",
                            icon: _unref(menu)
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonCol), { size: "2" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonButton), {
                        shape: "round",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('options')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            slot: "icon-only",
                            icon: _unref(ellipsisHorizontal)
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonCol), { size: "2" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonButton), {
                        shape: "round",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('share')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            slot: "icon-only",
                            icon: _unref(shareOutline)
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonCol), { size: "2" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonButton), {
                        shape: "round",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('fav-toggle')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            slot: "icon-only",
                            class: _normalizeClass(__props.isFav && 'is-fav'),
                            icon: _unref(favIcon)
                          }, null, 8, ["class", "icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ], 64))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})